import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TextService } from '../../../../../core/services/text.service';

@Component({
  selector: 'app-base-input',
  templateUrl: './base-input.component.html',
  styleUrl: './base-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BaseInputComponent<T> {
  @Input() options: T = {
    label: 'just control',
    control: new FormControl(null, [Validators.required]),
  } as any;
  get isRequired() {
    return ((this.options as any).control as FormControl)?.hasValidator(
      Validators.required);
  }
  private _subscriptions: Subscription[] = [];
  private textService: TextService = inject(TextService);
  id = '';

  /**
   *
   */
  constructor() {
    this.id = this.textService.generateRandomString();
  }

  ngOnChanges() {
    if (!(this.options as any).control)
      (this.options as any).control = new FormControl(null, [
        Validators.required,
      ]);
  }
  _(sub: Subscription) {
    this._subscriptions.push(sub);
  }
}
